module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "foreword",
      "id": "_idContainer000",
      "role": "doc-foreword"
    }
  }, [_c('p', {
    staticClass: "pl-fl-header"
  }, [_c('b', [_vm._v("From the dark tunnel came the roaring sound of the subway train.")])]), _vm._v(" "), _c('p', {
    staticClass: "fl-fl-roman"
  }, [_vm._v("Jostled by the crowd, Rachelle swam against the current, but the tide of humanity pushed her toward the yellow safety boundary painted on the platform floor. Frowning, she held on tight to her purse and tried to shimmy her way through the crowd.")]), _vm._v(" "), _c('p', {
    staticClass: "fl-fl-roman"
  }, [_vm._v("The flat of a hand on her back startled her, and she jerked just as she was shoved hard, causing her to misstep and propelling her to the very edge of the platform. She lost her balance, her arms windmilling.")]), _vm._v(" "), _c('p', {
    staticClass: "fl-fl-roman"
  }, [_vm._v("Terror ripped a desperate scream from her as she plummeted off the platform and onto the tracks.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b9f920f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Introduction.vue
// module id = 57
// module chunks = 0